import Overview from './Overview'
import EditBlogPost from './EditBlogPost'

export const blogRoutes = [{
    path: '/blog',
    name: 'Blog posts',
    component: Overview,
    meta: { requiresAuth: true, minRole: 1}
  },
  {
    path: '/blog/:id',
    name: 'EditBlogPost',
    component: EditBlogPost,
    meta: { requiresAuth: true, minRole: 2}
  }];


// WEBPACK FOOTER //
// ./src/CORE/modules/BLOG/routes.js